import React from 'react';
import { Container } from 'react-bootstrap';

const TestiMonialsDetails = ({testiMonialDetail}) => {
    const {name, address, description, img} = testiMonialDetail;
    console.log("testiMonialDetail"+testiMonialDetail)
    return (
        <div fluid='true'  className="item ">
            <div className="shadow-effect">
                {/* <img className="img-circle" src={img} alt='pic' /> */}
                <span className='img-circle'>{name.charAt(0)}</span>
                <p>{description}</p>
            </div>
            <div className="testimonial-name">
                <h5>{name}</h5>
                <small>{address}</small>
            </div>
        </div>
    );
};

export default TestiMonialsDetails;